import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { PortalAppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

export function bootstrapApplication() {

  platformBrowserDynamic().bootstrapModule(PortalAppModule)
    .catch(err => console.error(err));
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/tslint-loader!./~/source-map-loader!./projects/nxi-ng-portal/src/main.ts